"use client";
import { CashbackTypes } from "@/api/cashback";
import { getWheelApi } from "@/api/cashWheel";
import { cleanBounsApi, toggleUserBounsApi } from "@/api/user";
import TipsModal from "@/components/TipsModal";
import { useRouter } from "@/i18n/routing";
import { useGlobalNoticeStore } from "@/stores/useGlobalNoticeStore";
import { usePollingStore } from "@/stores/usePollingStore";
import { useWalletStore } from "@/stores/useWalletStore";
import { server } from "@/utils/client";
import { useRequest } from "ahooks";
import { Badge, Dialog, Switch, Toast } from "antd-mobile";
import { useTranslations } from "next-intl";
import React, { FC, useMemo } from "react";
import { shallow } from "zustand/shallow";
import "./style.scss";

/**
 * @description 列表组件
 * @param {string} type 使用类型
 * @param {(params: any) => void} callbackFun 回调方法
 */
export interface ItemComProps {
    type?: string;
}
const getCashBackApi = async () => {
    return server
        .request<CashbackTypes>({
            url: "/v1/api/front/activity_cash",
            method: "post",
        })
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return {
                rules: [],
                last_period: { end_time: 0, start_time: 0 },
                next_period: {
                    end_time: 0,
                    start_time: 0,
                },
                amount: 0,
                bet: 0,
                status: "expired",
            };
        });
};

const ItemCom: FC<ItemComProps> = ({ type = "login" }) => {
    const t = useTranslations("ProfilePage");
    const tall = useTranslations();
    const refresh = usePollingStore((state) => state.refresh);
    const router = useRouter();
    const { unread, userUnread } = useGlobalNoticeStore(
        (state) => ({
            unread: state.unread,
            userUnread: state.userUnred,
        }),
        shallow
    );

    const is_open_no_bonus = useWalletStore((state) => state.wallet.is_open_no_bonus);
    const [switchValue, setSwitchValue] = React.useState<boolean>(is_open_no_bonus === 1 || false);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    const noBonusRef = React.useRef<any>(null);

    const { data: cashback } = useRequest<any, any>(getCashBackApi, {
        pollingErrorRetryCount: 1,
    });

    // const vip_cashback = useVipStore((state) => state.vipData?.vip_cashback ?? 0);
    const vip_cashback = useMemo(() => {
        if (!cashback?.rules?.length) return 0;
        const len = cashback?.rules.length;
        const rules = cashback?.rules.sort((a: any, b: any) => a.level - b.level);
        return rules[len - 1].cashback;
    }, [cashback]);

    const changeValue = async (value: boolean) => {
        const confirmRes = await Dialog.confirm({
            content: (
                <div className="text-[#fff]">{value ? t("switchOpen") : t("switchClose")}</div>
            ),
            confirmText: t("sure"),
            cancelText: t("cancel"),
            bodyStyle: {
                backgroundColor: "#373737",
                color: "#fff",
            },
            bodyClassName: "customConfirm",
        });
        if (!confirmRes) return;
        setIsLoading(true);
        try {
            const res = await toggleUserBounsApi(value ? 1 : 0);
            if (!(res?.code && res?.data?.code === 0)) {
                throw new Error("error");
            }
            setSwitchValue(value);
        } finally {
            setIsLoading(false);
        }
    };

    const doHandle = async () => {
        const confirmRes = await Dialog.confirm({
            content: <div className="text-[#fff]">{t("clean")}</div>,
            confirmText: t("sure"),
            cancelText: t("cancel"),
            bodyStyle: {
                backgroundColor: "#373737",
                color: "#fff",
            },
            bodyClassName: "customConfirm",
        });
        if (!confirmRes) return;
        const res = await cleanBounsApi(1);

        if (res?.code && [6001, 6002].includes(res?.data?.code)) {
            const str = t(`bouns${res?.data?.code}`);
            Toast.show({
                content: str,
                icon: "fail",
            });
        }
        Toast.show({
            content: t("success"),
            icon: "success",
        });
        // const walletRes = await getUserMoneyApi();
        // setWallet(walletRes?.data);

        refresh && refresh();
    };
    const links = [
        // { label: "gratis", desc: "gratisDesc", icon: "", url: "/", content: null },
        {
            label: "no bonus",
            desc: "",
            icon: "icon-chongzhihongchong",
            url: "/nobonus",
            content: null,
            suffix: (
                <i className="iconfont icon-22222_huaban1 relative top-[2px] block text-[.16rem] leading-[1] text-[#f6cf1e]"></i>
            ),
        },
        {
            label: t("company"),
            desc: "",
            icon: "icon-huo",
            color: "#ff9b23",
            url: "/affiliate",
            content: null,
        },
        {
            label: t("pray"),
            desc: "",
            icon: "icon-mianfei",
            url: "/cashWheel",
            content: null,
        },
        {
            label: t("cashback", { max: vip_cashback }),
            desc: "",
            icon: "icon-qiandai",
            url: "/cashback",
            content: null,
        },
        {
            label: t("gamblingBets"),
            desc: "",
            icon: "icon-zhuanjiangjin",
            url: "/betrecord",
            content: null,
        },
        {
            label: t("transactions"),
            desc: "",
            icon: "icon-jiaoyi",
            url: "/transactions",
            content: null,
        },
        {
            label: t("message"),
            desc: "",
            icon: "icon-xiaoxi3-copy",
            url: "/notification",
            content: unread || userUnread ? Badge.dot : null,
        },
        {
            label: tall("HomePage.Contante"),
            desc: "",
            icon: "icon-dakaixinxi",
            url: "/concat",
            content: unread || userUnread ? Badge.dot : null,
        },
        {
            label: "Alterar a senha",
            desc: "",
            icon: "icon-xiugaimima",
            url: "/changePassword",
            content: null,
        },
    ];
    const routerHandler = (item: any) => {
        switch (item.url) {
            case "/cashWheel":
                {
                    getWheelApi().then((res) => {
                        if (!Array.isArray(res.data) && !!res.data.activities) {
                            router.push(item.url);
                        } else {
                            Toast.show("The event is not open");
                        }
                    });
                }
                break;
            case "/nobonus":
                noBonusRef.current?.onOpen();
                break;
            default:
                router.push(item.url);
                break;
        }
    };

    return (
        <div className="itemCom-box">
            {links.map((item, index) => (
                <div className={`box-item`} onClick={() => routerHandler(item)} key={index}>
                    <div className={`${item.desc ? "box-item__left" : ""}`}>
                        <Badge content={item.content} style={{ left: "20px" }}>
                            <div className="content">
                                <i
                                    className={`iconfont ${item.icon} text-[#789098]`}
                                    style={{ fontSize: "24px" }}
                                ></i>
                                <span>{item.label}</span>
                                {item.suffix}
                            </div>
                            {item.desc && <p className={"desc"}>{t(item.desc)}</p>}
                        </Badge>
                    </div>

                    <div>
                        <span className="iconfont icon-xiangyou1 text-[#7791a8]"></span>
                    </div>
                </div>
            ))}
            <TipsModal
                ref={noBonusRef}
                title={
                    <div className={"flex items-center text-[#11de68]"}>
                        <i
                            className={"iconfont icon-liwuhuodong mr-[0.0694rem] text-[0.2778rem]"}
                        ></i>
                        No Bonus
                    </div>
                }
                className="profilePageTipModals"
            >
                <div className="flex flex-row items-center justify-between p-[8px]">
                    <span className="text-[#fff]">{t("bounsTitle1")}</span>
                    <Switch
                        loading={isLoading}
                        style={{
                            "--checked-color": "#11de68",
                            "--height": "24px",
                            "--width": "48px",
                        }}
                        checked={switchValue}
                        onChange={changeValue}
                    ></Switch>
                </div>
                <ul
                    className={
                        "ml-[0.1389rem] list-decimal pl-[0.1rem] pt-[.1rem] text-[0.12rem] text-[#fff]"
                    }
                >
                    <li className="mt-[.06rem]">{t("bonusDesc4")}</li>
                    <li className="mt-[.06rem]">{t("bonusDesc5")}</li>
                    <li className="mt-[.06rem]">{t("bonusDesc6")}</li>
                </ul>
                <div className="mt-[.15rem] flex items-center justify-center pb-[.2rem]">
                    <a
                        onClick={doHandle}
                        className="w-[100%] rounded-[20px] bg-[#11de68] px-[.1rem] py-[.12rem] text-center text-[.14rem] font-bold text-[#1f2830]"
                    >
                        {t("boundsBtn")}
                    </a>
                </div>
            </TipsModal>
        </div>
    );
};

export default ItemCom;
